exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoces-container[data-v-7d89ab06]{width:65%;padding-bottom:200px}.resources-container[data-v-7d89ab06]{width:35%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}h4[data-v-7d89ab06]{font-size:18px}.card-period-not-closed[data-v-7d89ab06]{font-size:15px;min-height:unset}.card-period-not-closed .ba-top .ba-title[data-v-7d89ab06]{font-size:15px}.card-period-not-closed .ba-top .ba-icon[data-v-7d89ab06]{width:35px;height:35px}.card-period-not-closed .ba-top .ba-icon builderall-icon[data-v-7d89ab06]{--builderall-icon-size:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d89ab06","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/office/js/components/invoices/BillingTab.vue
// module id = +4um
// module chunks = 0